<span class="closeModal pull-right" (click)="cancelar()"><i class="fa fa-times"></i></span>
<div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-12">
        <h2> Ficha Médica - Avances
            <configTools [rowsExport]="rowsExport"
                         [Title]="tituloTabla"
                         (AddChange)="add($event)"
                         [eliminando]="eliminando"
                         [Permiso]="permisoEdicion"></configTools>
        </h2>
    </div>
</div>
<div *ngIf="!buscando" class="wrapper wrapper-content animated fadeInRight">
  <div class="row">
    <div class="col-lg-12">
      <div class="header">
        <div class="ibox-content">
          <div>
            <mat-error *ngIf="eliminacionInvalida" class="eliminacionInvalida">{{MensajeError}}</mat-error>
            <div class="table table-striped">
              <p-table #dt [value]="avances" [rows]="10" [paginator]="true" [rowHover]="true" dataKey="id"
                       currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} Avances" [showCurrentPageReport]="true">
                <ng-template pTemplate="header">
                  <tr>
                    <th style="width: 6rem" pSortableColumn="fecha">Fecha <p-sortIcon field="fecha"></p-sortIcon></th>
                    <th pSortableColumn="avance">Avance <p-sortIcon field="avance"></p-sortIcon></th>
                    <th style="width: 6rem"></th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-avance let-rowIndex="rowIndex">
                  <tr>
                    <td style="text-align:center">{{avance.fecha|date:'dd/MM/yyyy'}}</td>
                    <td>{{avance.avance}}</td>
                    <td>
                      <button pButton pRipple pTooltip="Editar" tooltipPosition="bottom" icon="pi pi-pencil" class="btn btn-xs btn-warning" (click)="edit(avance, rowIndex)"></button>
                      <button *ngIf="permisoEdicion" pButton pRipple pTooltip="Eliminar" tooltipPosition="bottom" icon="pi pi-trash" class="btn btn-xs  btn-danger" (click)="delete(avance)"></button>
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
